import { render, staticRenderFns } from "./export-proof-detail-header.vue?vue&type=template&id=3d6e6cc8"
import script from "./export-proof-detail-header.vue?vue&type=script&lang=js"
export * from "./export-proof-detail-header.vue?vue&type=script&lang=js"
import style0 from "./export-proof-detail-header.vue?vue&type=style&index=0&id=3d6e6cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports